module.exports = __webpack_public_path__ + "img/tote.0608b289.svg";